import { ReviewApiClient } from "@/clients/reviewApiClient";
import { MatchDecisionResult } from "@/types/review";

/** FIN-1071: decisions on a matcher's Review item, the same for every matcher. */
export class MatchReviewService {
  /** Approve a link alternative (posts nothing) or a journal alternative ("book it"). */
  approve(suggestionId: string, alternativeId: string): Promise<MatchDecisionResult> {
    return ReviewApiClient.decideMatch(suggestionId, { kind: "approve", alternativeId });
  }

  /** Reject a link; the target booking stays untouched and the item is matched again. */
  rejectLink(suggestionId: string, reason: string): Promise<MatchDecisionResult> {
    return ReviewApiClient.decideMatch(suggestionId, { kind: "reject", reason });
  }
}
